import React from 'react';
// import CravoInput from './CravoInput'
import UsaDuration00 from '../../usa/components/UsaDuration00'
import { p, pi, pInd } from '../../components/utils/paramIds';
import { cl, globs, getTime } from '../../components/utils/utils';
import { sendArray, checkSendArray, getZValue } from '../../components/utils/http';
import { showSelect, showInput, showFUISelect } from '../../components/utils/reactUtils';
import { getParamId2 } from '../../usa/utils/utils';

const INPUTIDX_INTEMP = 0
const INPUTIDX_OUTTEMP = 1
const INPUTIDX_HUM = 2
const INPUTIDX_CO2 = 3
const INPUTIDX_LITE = 4
const INPUTIDX_WINSPD = 5
const INPUTIDX_WINDIR = 12
const INPUTIDX_BHEAT1 = 6
const INPUTIDX_BHEAT2 = 7
const INPUTIDX_BHEAT3 = 8
const INPUTIDX_BHEAT4 = 9
const INPUTIDX_BHEAT5 = 10
const INPUTIDX_RAIN = 18
const OVERRIDE_SENSOR_NONE = 64
// Controller default is None (64). Cloud often stores 0 with no trigger/limit — not Inside Temperature.
const OVERRIDE_SENSOR_NONE_ALIASES = [-1, 64, 75, 255]
// Generic Sensor 1-128, matching the firmware InputMap enum (GSNS1=77 ... GSNS128=204).
// Encoded as 76 + N; doesn't collide with the None aliases above.
const GENERIC_SENSOR_BASE = 77
const GENERIC_SENSOR_MAX = 204
const GENERIC_SENSOR_COUNT = 128
// Simple dotted compare: show Generic Sensor when fwVersion is above 1.18.30
// (e.g. 1.18.315). 1.18.30 and older stay hidden.
const MIN_GENERIC_SENSOR_FW = [1, 18, 30]
const OVERRIDE_SENSOR_OPT_KEYS = [
  OVERRIDE_SENSOR_NONE,
  INPUTIDX_INTEMP,
  INPUTIDX_OUTTEMP,
  INPUTIDX_HUM,
  INPUTIDX_CO2,
  INPUTIDX_LITE,
  INPUTIDX_WINSPD,
  INPUTIDX_WINDIR,
  INPUTIDX_BHEAT1,
  INPUTIDX_BHEAT2,
  INPUTIDX_BHEAT3,
  INPUTIDX_BHEAT4,
  INPUTIDX_BHEAT5,
  INPUTIDX_RAIN,
  GENERIC_SENSOR_BASE,
]

class PIDAdvancedSettings extends React.Component {
  constructor(props) {
    super(props);
    let [z, u, c, i] = props.zuci.split("-")
    let ids = this.getDBIds()
    this.z=z
    this.c2 = +c + 40 * u
    //     cl(c2)
//     cl("reading values")
    this.state=this.getCurrentVals(this.z,this.c2,ids)
//     this.state = {
//       supplyPump: this.getParam(z, c2, ids.supplyPump),
//       p: this.getParam(z, c2, ids.P),
//       i: this.getParam(z, c2, ids.I),
//       d: this.getParam(z, c2, ids.D),
//       override_dir: this.getParam(z, c2, ids.override_dir),
//       override_action_target: this.getParam(z, c2, ids.override_action_target),
//       override_trigger: this.getParam(z, c2, ids.override_trigger),
//       sensor: this.getParam(z, c2, ids.override_sensor),
//       override_limit: this.getParam(z, c2, ids.override_limit),
//       //       output_type: this.getParam(z,c2,ids.supplyPump),
//       hold_delay: this.getParam(z, c2, ids.hold_delay),
//       c: c,
//       z: z,
//     }
//     cl(ids)
    //     cl(this.state)
    this.props.getValue(props.ind, { type: "array", count: 5 })// basically fake
    this.props.saves.push(this.onSave)
    this.subscribe_updateFui=globs.events.subscribe("updateFui", this.updateFui)

    //     cl(this.props.value)
    //     this.getDBVars()
  }

  componentDidMount=()=>{
    let ids = this.getDBIds()
    this.setState(this.getCurrentVals(this.z, this.c2, ids))
  }

  componentWillUnmount=()=>{
    this.subscribe_updateFui.remove()
//     this.subscribe_savePageEvent.remove()
  }

  getCurrentVals=(z,c2,ids)=>{
//     cl("get current vals")
    return {
      supplyPump: this.getParam(z, c2, ids.supplyPump),
      p: this.getParam(z, c2, ids.P),
      i: this.getParam(z, c2, ids.I),
      d: this.getParam(z, c2, ids.D),
      override_dir: this.getParam(z, c2, ids.override_dir),
      override_action_target: this.getParam(z, c2, ids.override_action_target),
      override_trigger: this.getParam(z, c2, ids.override_trigger),
      sensor: this.getOverrideSensor(z, c2, ids),
      override_limit: this.getParam(z, c2, ids.override_limit),
      //       output_type: this.getParam(z,c2,ids.supplyPump),
      hold_delay: this.getParam(z, c2, ids.hold_delay),
      c: c2,
      z: z,
    }
  }

  updateFui=(cmd)=>{
    if (cmd === "goingToDefaults") {
      this.changed = false
    }
    if (this.changed) { return }
    let ids = this.getDBIds()
    this.setState(this.getCurrentVals(this.z, this.c2, ids))
  }

  getParam = (z, c, id, defaultVal = 0) => {
    let ret = getZValue(z, c, id)
    if (ret === undefined || ret === null || ret === '') {
      return defaultVal
    }
    if (typeof ret === 'object') {
      ret = ret.val
      if (ret === undefined || ret === null || ret === '') {
        return defaultVal
      }
    }
    let num = +ret
    return isNaN(num) ? defaultVal : num
  }

  getOverrideSensor = (z, c2, ids) => {
    let sensor = this.getParam(z, c2, ids.override_sensor, OVERRIDE_SENSOR_NONE)
    if (OVERRIDE_SENSOR_NONE_ALIASES.includes(sensor)) {
      return OVERRIDE_SENSOR_NONE
    }
    // Cloud DB often stores 0 when controller means None (64)
    if (sensor === INPUTIDX_INTEMP && this.isUnsetCloudOverride(z, c2, ids)) {
      return OVERRIDE_SENSOR_NONE
    }
    return sensor
  }

  isUnsetCloudOverride = (z, c2, ids) => {
    return this.getParam(z, c2, ids.override_trigger, 0) === 0
      && this.getParam(z, c2, ids.override_limit, 0) === 0
  }

  normalizeOverrideSensorForSave = (sensor) => {
    return OVERRIDE_SENSOR_NONE_ALIASES.includes(+sensor) ? OVERRIDE_SENSOR_NONE : +sensor
  }

  getGenericSensorNames = () => {
    let { siteId, zoneId } = this.props.current || {}
    // Loose equality matches the established lookup in GenericSensors00.js —
    // siteId/zoneId types don't always match strictly across sources.
    let sensors = globs.sensorsInfo?.info?.find(s => (s.siteId == siteId) && (s.zoneId == zoneId))
    return sensors?.sensorNames || {}
  }

  // Only offer sensors actually mapped to a physical input. A custom name is
  // not a mapping. pearl_gen_sens_conf.mapping: 0 = None, non-zero = mapped
  // (29 = MBUS for generic sensors). Unwrap via getZValue so {val:0} objects
  // are not treated as mapped.
  getMappedGenericSensorIndices = () => {
    let gwType = this.props.current?.gwType || 1800
    let tab = pInd[gwType]?.pearl_gen_sens_conf
    if (!tab) { return null }
    let mappingPid = +getParamId2(1900, "pearl_gen_sens_conf", "mapping")
    let mult = tab[2]
    let mapped = new Set()
    for (let idx = 0; idx < GENERIC_SENSOR_COUNT; idx++) {
      let mapping = +getZValue(+this.z, 240, mappingPid + mult * idx) || 0
      if (mapping) { mapped.add(idx + 1) }
    }
    return mapped
  }

  supportsGenericSensor = () => {
    let gwId = this.props.current?.gwId || this.props.zoneInfo?.gatewayId
    const gateway = globs.gatewaysInfo?.info?.find(gw => gw.gatewayId === gwId)
    if (!gateway?.fwVersion || gateway.gatewaySubType === "HydroR") return false
    const parts = String(gateway.fwVersion).split(".")
    if (parts.length < 3) return false
    const major = parseInt(parts[0], 10)
    const minor = parseInt(parts[1], 10)
    const build = parseInt(parts[2], 10)
    if ([major, minor, build].some(n => Number.isNaN(n))) return false
    const [tMaj, tMin, tBld] = MIN_GENERIC_SENSOR_FW
    if (major !== tMaj) return major > tMaj
    if (minor !== tMin) return minor > tMin
    return build > tBld
  }

  getOverrideSensorOptKeys = () => {
    if (this.supportsGenericSensor()) return OVERRIDE_SENSOR_OPT_KEYS
    return OVERRIDE_SENSOR_OPT_KEYS.filter(k => k !== GENERIC_SENSOR_BASE)
  }

  showOverrideSensorSelect = (onChange) => {
    let extraCustom = this.supportsGenericSensor() ? {
      genericSensorBase: GENERIC_SENSOR_BASE,
      genericSensorMax: GENERIC_SENSOR_MAX,
      genericSensorCount: GENERIC_SENSOR_COUNT,
      genericSensorNames: this.getGenericSensorNames(),
      genericSensorMappedIndices: this.getMappedGenericSensorIndices(),
    } : {}
    return showFUISelect(
      "fields", this.state.sensor, "sensor", -1,
      this.makeOverrideSensorOpts(), onChange, this.getValue,
      this.getOverrideSensorOptKeys(),
      extraCustom,
      {current: this.props.current, zoneInfo: this.props.zoneInfo, zuci: this.props.zuci},
    )
  }

  makeOverrideSensorOpts = () => ({
    [OVERRIDE_SENSOR_NONE]: { t: "None" },
    [INPUTIDX_INTEMP]: { t: "Inside Temperature" },
    [INPUTIDX_OUTTEMP]: { t: "Outside Temperature" },
    [INPUTIDX_HUM]: { t: "Relative Humidity" },
    [INPUTIDX_CO2]: { t: "CO2" },
    [INPUTIDX_LITE]: { t: "Outside Light" },
    [INPUTIDX_WINSPD]: { t: "Wind Speed" },
    [INPUTIDX_WINDIR]: { t: "Wind Direction" },
    [INPUTIDX_BHEAT1]: { t: "Analog Temperature 1" },
    [INPUTIDX_BHEAT2]: { t: "Analog Temperature 2" },
    [INPUTIDX_BHEAT3]: { t: "Analog Temperature 3" },
    [INPUTIDX_BHEAT4]: { t: "Analog Temperature 4" },
    [INPUTIDX_BHEAT5]: { t: "Analog Temperature 5" },
    [INPUTIDX_RAIN]: { t: "Rain" },
    [GENERIC_SENSOR_BASE]: { t: "Generic Sensor" },
  })

  putParam = (z, c, id, t, parms, val) => {// tab refers to our local (channel, id) tables
    parms.push({
      c: c,// zone wide
      d: val,
      f: 1,
      i: id,
      t: t,
      z: z,
    })
  }



  //   onChange=(type, valId, ind, e)=>{
  //     var vals={}
  //     let arr=this.props.value.slice(0)
  //     switch(type){
  //       case "inp":
  //         arr[ind]=e.currentTarget.value
  //         break
  //       case "check":
  //         arr[ind]=(e.currentTarget.checked)?1:0
  //         break
  //     }
  //     this.setState({arr: arr})
  //     this.props.onChange(this.props.ind, {value: arr})
  //   }

  getDBIds = () => {
    let gwType = this.props.current?.gwType || 1800
    if (!pInd[gwType]) { gwType = 1800 }
    let b = pInd[gwType].config_channels_configuration[0]
    let ids = {}
    ids.supplyPump = b + pi[gwType].config_channels_configuration.CD_supply_pump_generic
    ids.P = b + pi[gwType].config_channels_configuration.P
    ids.I = b + pi[gwType].config_channels_configuration.I
    ids.D = b + pi[gwType].config_channels_configuration.D
    ids.override_sensor = b + pi[gwType].config_channels_configuration.override_sensor
    ids.override_dir = b + pi[gwType].config_channels_configuration.override_dir
    ids.override_trigger = b + pi[gwType].config_channels_configuration.override_trigger
    ids.override_action_target = b + pi[gwType].config_channels_configuration.override_action_target
    ids.override_limit = b + pi[gwType].config_channels_configuration.override_limit
    ids.hold_delay = b + pi[gwType].config_channels_configuration.hold_delay
    //     cl(ids)
    return ids
  }

  //   getDBVars=()=>{
  //     let ids=this.getDBIds()
  //     cl(this.state)
  //     cl(ids)
  //   }

  onSave = () => {
    //     cl(this.state)
//     let [z, u, c, i] = this.props.zuci.split("-")
    let t = Math.floor(getTime())
    let ids = this.getDBIds()
    let parms = []
    let z=this.z
    let c2=this.c2// = +c + 40 * u
    //     cl(c2)
    this.putParam(z, c2, ids.supplyPump, t, parms, this.state.supplyPump)
    this.putParam(z, c2, ids.P, t, parms, this.state.p)
    this.putParam(z, c2, ids.I, t, parms, this.state.i)
    this.putParam(z, c2, ids.D, t, parms, this.state.d)
    this.putParam(z, c2, ids.override_sensor, t, parms, this.normalizeOverrideSensorForSave(this.state.sensor))
    this.putParam(z, c2, ids.override_dir, t, parms, this.state.override_dir)
    this.putParam(z, c2, ids.override_trigger, t, parms, this.state.override_trigger)
    this.putParam(z, c2, ids.override_action_target, t, parms, this.state.override_action_target)
    this.putParam(z, c2, ids.override_limit, t, parms, this.state.override_limit)
    this.putParam(z, c2, ids.hold_delay, t, parms, this.state.hold_delay)
//         cl(this.state)
//     cl(parms)
    checkSendArray(parms, this.props.current.virtual).then(r => { globs.events.publish("saveOK", true) })

    //     cl("saving")
  }

//   showInput = (val, valId, ind, onChange) => {
//     return (
//       <input
//         value={val}
//         style={{ width: 50, }}
//         type="number"
//         onChange={e => onChange("inp", valId, ind, e)}
//       />
//     )
//   }

  onChange = (type, valId, ind, e) => {//type, valId,ind,e
//     cl(type,valId,ind,e)
    globs.events.publish("savePageEnable", true)
    this.changed=true
    var vals
    switch (type) {
      case "hold_delay":
        vals = {hold_delay:valId.duration}
        break
      default:
//         cl([type, valId, ind, e])
        vals = {}
        vals[valId] = +e.currentTarget.value
        break
    }
    //     this.props.onChange(vals)
//     cl(vals)
    this.setState(vals)
    //     cl([a,b,c,d])

  }

  showTab1 = () => {
    let spOpts = { 0: { t: "None" } }
    for (let i = 0; i < 12; i++) { spOpts[i + 1] = { t: `Pump ${1 + i}` } }
    return (
      <table><tbody>
        <tr><td>
          {showSelect("supply", this.state.supplyPump, "supplyPump", -1, spOpts, this.onChange)}
        </td></tr>
        <tr><td>The supply pump will activate<br />
          when mixvalve opens past the<br />
          threshold set on the selected<br />
          pump's programming screen.
        </td></tr>
      </tbody></table>
    )
  }

  showTab2 = () => {
    return (
      <table><tbody>
        <tr><td>Setpoint</td></tr>
        <tr><td>
          <table><tbody>
            <tr><td>P</td><td>{showInput("fields", this.state.p, "p", -1, this.onChange, 70, 3)}</td></tr>
            <tr><td>I</td><td>{showInput("fields", this.state.i, "i", -1, this.onChange, 70, 3)}</td></tr>
            <tr><td>D</td><td>{showInput("fields", this.state.d, "d", -1, this.onChange, 70, 3)}</td></tr>
          </tbody></table>
        </td></tr>
      </tbody></table>
    )
  }

  showTab3 = () => {
    let so = this.makeOverrideSensorOpts()
    let od = {
      0: { t: "Greater Than" },
      1: { t: "Less Than" },
    }
    let oat = {
      0: { t: "at least" },
      1: { t: "at most" },
    }
    //     cl(this.state)
    return (
      <table><tbody>
        <tr><td>if the sensor
          {showSelect("fields", this.state.sensor, "sensor", -1, so, this.onChange, OVERRIDE_SENSOR_OPT_KEYS)}
          is</td></tr>
        <tr><td>
          {showSelect("fields", this.state.override_dir, "override_dir", -1, od, this.onChange)}
          {showInput("fields", this.state.override_trigger, "override_trigger", -1, this.onChange)}
        </td></tr>
        <tr><td>then limit
          {showSelect("fields", this.state.override_action_target, "override_action_target", -1, oat, this.onChange)}
          to
          {showInput("fields", this.state.override_limit, "override_limit", -1, this.onChange)}
        </td></tr>
      </tbody></table>
    )
  }

  showTab4 = () => {
    return (
      <table><tbody>
        <tr><td>
          <UsaDuration00
            value={this.state.hold_delay}
            valueId="hold_delay"
            onChange={v => this.onChange("hold_delay", v)}
          />

        </td></tr>
      </tbody></table>
    )
  }

  showAdvanced = () => {
    let spOpts = { 0: { t: "None" } }
    for (let i = 0; i < 12; i++) { spOpts[i + 1] = { t: `Pump ${1 + i}` } }
    let od = {
      0: { t: "Greater Than" },
      1: { t: "Less Than" },
      2: { t: "Equal To" },
    }
    let oat = {
      0: { t: "at least" },
      1: { t: "at most" },
    }
     const screenWidth = window.innerWidth;
    const supplyPump = {
      display: "flex",
      alignItems: screenWidth < 600 ? 'start' : 'center',
      columnGap: "10px",
      flexWrap: screenWidth < 600 ? 'wrap' : 'nowrap',
      flexDirection: screenWidth < 600 ? 'column' : 'row',
      marginBottom: "15px"
    };

    const override = {
      display: "flex",
      alignItems: "center",
      justifyContent: "flex-start",
      flexWrap: "wrap",
      width: "100%",
      maxWidth: "100%",
      columnGap: "8px",
      rowGap: "8px",
      marginBottom: "15px"
    };

    const PID_setPoint = {
      display: "flex",
      alignItems: screenWidth < 600 ? 'start' : 'center',
      justifyContent: "start",
      width: "100%",
      gap: "10px",
      // backgroundColor: "cyan",
      flexDirection: screenWidth < 600 ? 'column' : 'row',
      marginBottom: "15px"
    };
    return (
      //new coding

      <div>
          <br></br>
          {/* PID-Setpoint */}
          <div style={PID_setPoint}>
            <div
              style={{ flexShrink: 0, marginRight: "10px"}}
            >
              PID-Setpoint
            </div>
            <div
              style={{
                display: "flex",
                width: "100%",
                gap: '8px',
                alignItems: screenWidth < 500 ? 'start' : 'center',
                flexDirection: screenWidth < 500 ? "column" : "row"
              }}
            >

              <div
              style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                P {showInput("fields", this.state.p, "p", -1, this.onChange, "80%", 3)}
              </div>
              <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                I {showInput("fields", this.state.i, "i", -1, this.onChange, "80%", 3)}
              </div>
              <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                D  {showInput("fields", this.state.d, "d", -1, this.onChange, "80%", 3)}
              </div>

            </div>
          </div>

          {/* Override */}
          <div className="pid-override-row" style={override}>
            <span style={{ flexShrink: 0 }}>OVERRIDE</span>
            <span className="pid-override-clause">
              <span>if</span>
              {this.showOverrideSensorSelect(this.onChange)}
              <span>is</span>
              {showFUISelect("fields", this.state.override_dir, "override_dir", -1, od, this.onChange, this.getValue)}
              {showInput("fields", this.state.override_trigger, "override_trigger", -1, this.onChange, "100px")}
            </span>
            <span className="pid-override-clause">
              <span>then limit</span>
              {showFUISelect("fields", this.state.override_action_target, "override_action_target", -1, oat, this.onChange, this.getValue)}
              <span>to</span>
              {showInput("fields", this.state.override_limit, "override_limit", -1, this.onChange, "70px")}
            </span>
          </div>

          {/* supplypump */}
          <div style={supplyPump}>
            <div style={{ flexShrink: 0 }}>
              SUPPLY PUMP
            </div>
            <div>
              {showFUISelect("supply", this.state.supplyPump, "supplyPump", -1, spOpts, this.onChange, this.getValue)}
            </div>
            <div>
              The supply pump will activate
              when mixvalve opens past the
              threshold set on the selected
              pump's programming screen.
            </div>

          </div>
        </div>

      // old coding
      // <div>
      //   <br></br>
      //   <div style={{ display: "flex", width: "100%" }}>

      //     <div style={{ flex: 1 }}>
      //       SUPPLY PUMP
      //     </div>

      //     <div style={{ flex: 1, marginLeft: "10px" }}>
      //       PID
      //     </div>

      //     <div style={{ flex: 1, marginLeft: "-50px" }}>
      //       OVERRIDE
      //     </div>

      //     <div style={{ flex: 1, marginLeft: "10px" }}>
      //       HOLD POSITION DELAY
      //     </div>

      //   </div>

      //   <br></br>
      //   <div style={{ display: "flex", width: "100%" }}>

      //     <div style={{ flex: 1 }}>
      //       {showFUISelect("supply", this.state.supplyPump, "supplyPump", -1, spOpts, this.onChange, this.getValue)}
      //       The supply pump will activate
      //       when mixvalve opens past the
      //       threshold set on the selected
      //       pump's programming screen.
      //     </div>

      //     <div style={{ flex: 1, marginLeft: "10px" }}>
      //       Setpoint
      //       <br></br>
      //       <br></br>
      //       <div style={{ display: "flex", width: "60%" }}>

      //         <div style={{ flex: 0 }}>
      //           P
      //         </div>

      //         <div style={{ flex: 1, marginLeft: "10px" }}>
      //           {showInput("fields", this.state.p, "p", -1, this.onChange, "100%")}
      //         </div>

      //       </div>
      //       <br></br>
      //       <div style={{ display: "flex", width: "60%" }}>

      //         <div style={{ flex: 0 }}>
      //           I
      //         </div>

      //         <div style={{ flex: 1, marginLeft: "15px" }}>
      //           {showInput("fields", this.state.i, "i", -1, this.onChange, "100%")}
      //         </div>

      //       </div>
      //       <br></br>
      //       <div style={{ display: "flex", width: "60%" }}>

      //         <div style={{ flex: 0 }}>
      //           D
      //         </div>

      //         <div style={{ flex: 1, marginLeft: "10px" }}>
      //           {showInput("fields", this.state.d, "d", -1, this.onChange, "100%")}
      //         </div>

      //       </div>

      //     </div>

      //     <div style={{ flex: 1, marginLeft: "-50px" }}>
      //       <br></br>
      //       <div style={{ display: "flex", width: "100%" }}>

      //         <div style={{ flex: 1 }}>
      //           If the sensor
      //         </div>

      //         <div style={{ flex: 1, marginLeft: "5px" }}>
      //           {showFUISelect("fields", this.state.sensor, "sensor", -1, so, this.onChange, this.getValue)}
      //         </div>

      //         <div style={{ flex: 1, marginLeft: "5px" }}>
      //           is
      //         </div>

      //       </div>

      //       <br></br>
      //       <div style={{ display: "flex", width: "100%" }}>

      //         <div style={{ flex: 1 }}>
      //           {showFUISelect("fields", this.state.override_dir, "override_dir", -1, od, this.onChange, this.getValue)}
      //         </div>

      //         <div style={{ flex: 1, marginLeft: "20px" }}>
      //           {showInput("fields", this.state.override_trigger, "override_trigger", -1, this.onChange, "100px")}
      //         </div>

      //       </div>

      //       <br></br>
      //       <div style={{ display: "flex", width: "100%" }}>

      //         <div style={{ flex: 1 }}>
      //           then limit
      //         </div>

      //         <div style={{ flex: 1, marginLeft: "5px" }}>
      //           {showFUISelect("fields", this.state.override_action_target, "override_action_target", -1, oat, this.onChange, this.getValue)}
      //         </div>

      //         <div style={{ flex: 1, marginLeft: "5px" }}>
      //           to
      //         </div>

      //         <div style={{ flex: 1, marginLeft: "5px" }}>
      //           {showInput("fields", this.state.override_limit, "override_limit", -1, this.onChange, "100px")}
      //         </div>

      //       </div>

      //     </div>


      //     <div style={{ flex: 1, marginLeft: "10px" }}>
      //       <br></br>
      //       <div style={{ display: "flex", width: "100%" }}>
      //         <C18Duration00 parms={{
      //          width:"60%",
      //          duration:this.state.hold_delay,
      //          onChange:e=>this.onChange("hold_delay", e),
      //          saveOK:true,
      //         }}/>
      //       </div>
      //     </div>

      //   </div>

      // </div>

    )
  }

  getValue=(index,valueDescription)=>{
  }

  render() {
    return (
      <div>
        {this.showAdvanced()}
      </div>
    )
  }

}

export default PIDAdvancedSettings;
